import { Text } from "@overmap-ai/blocks"
import { type AssetAttachment, type Stored, UNLABELLED_ASSET_LABEL } from "@overmap-ai/common"
import { selectAssetById, selectUserById } from "@overmap-ai/core"
import { Link } from "@tanstack/react-router"
import { memo } from "react"

import { interactiveTextCva } from "../../cva"
import { ProjectTimelineItemType } from "../../enums/projects"
import { useAppSelector } from "../../store"
import { formatCompactDate } from "../../utils/date"
import { getUserDisplayLabel } from "../../utils/users"
import { AssetTypeIcon } from "../Icons/AssetTypeIcon"
import { AssetIndexLabel } from "../IndexLabels/AssetIndexLabel"
import { ProjectTimelineCard } from "./ProjectTimelineCard"

interface ProjectTimelineAssetAttachmentItemProps {
	assetAttachment: Stored<AssetAttachment>
}

export const ProjectTimelineAssetAttachmentItem = memo<ProjectTimelineAssetAttachmentItemProps>((props) => {
	const { assetAttachment } = props

	const user = useAppSelector(selectUserById(assetAttachment.created_by ?? -1))
	const asset = useAppSelector(selectAssetById(assetAttachment.asset))!

	return (
		<ProjectTimelineCard type={ProjectTimelineItemType.ASSET_ATTACHMENT}>
			<Text size="sm" accentColor="base" className="min-w-0">
				<Text highContrast>{getUserDisplayLabel(user)}</Text>
				&nbsp;attached a file to asset&nbsp;
				<Link
					from="/$organizationId/$projectId"
					to="/$organizationId/$projectId/assets/$assetId"
					params={{ assetId: asset.uuid }}
				>
					<AssetTypeIcon className="align-sub" assetTypeId={asset.asset_type} />
					&nbsp;
					<Text className={interactiveTextCva()} accentColor="base">
						<AssetIndexLabel assetId={asset.uuid} highContrast />
						&nbsp;
						<Text>{asset.label || UNLABELLED_ASSET_LABEL}</Text>
					</Text>
				</Link>
				<Text accentColor="base">&nbsp;&#8226;&nbsp;{formatCompactDate(assetAttachment.submitted_at)}</Text>
			</Text>

			<Text size="sm" accentColor="base" className="min-w-0 truncate">
				{assetAttachment.file_name}
			</Text>
		</ProjectTimelineCard>
	)
})
ProjectTimelineAssetAttachmentItem.displayName = "ProjectTimelineAssetAttachmentItem"
